import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLogin: false,
  userInfo: {
    user: null,
    accessToken: null,
    refreshToken: null,
  },
  selectedUser: {
    user: null,
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    toggleLogin: (state, { payload }) => {
      state.isLogin = payload?.isLogin;
      state.userInfo = payload?.userInfo;
    },
    updateUserToken: (state, { payload }) => {
      state.userInfo.accessToken = payload?.accessToken;
      state.userInfo.refreshTokenn = payload?.refreshTokenn;
    },
    updateUser: (state, { payload }) => {
      state.userInfo.user = payload;
    },
    selectedUser: (state, { payload }) => {
      state.selectedUser = payload;
    },
  },
});

export const { toggleLogin, updateUser, updateUserToken, selectedUser } =
  authSlice.actions;

export default authSlice.reducer;
